
namespace RioERP.Inventory {
    export class BookOutwardColumns {
        static columnsKey = 'Inventory.BookOutward';
    }
}